export enum AlertEnum
{
  Success = 1,
  Warning,
  Error,
  Information,
}

export enum InfoEnum
{
  Normal = 1
}

export enum DialogEnum
{
  Normal = 1,
  Advise,
  Information
}

export enum OptionEnum
{
  Positive = 1,
  Negative
}
